import React from 'react';
import CheckmarkCircle from '/images/icons/checkmark-circle.svg';
import { copyFor } from 'config';
import { Modal, Text, FlexCrate, Logo } from '@perch-labs/shrike';
import { trackClickEvent } from 'domain/tracking';
import { getPaymentCopy } from '../../../../payment-methods.utils';
import { PaymentCard } from '../../../../payment-methods.style';
import { CloseButton, ButtonWrapper, StyledSVG } from './confirmation.style';

const getCopy = copyFor(
  'settings.paymentInformation.addPaymentMethodModal.screens.confirmation'
);
interface Props {
  close: () => void;
  context: AddPaymentMethodContext;
}

export const Confirmation = ({ close, context }: Props) => {
  const { updatedPlans, isActivePlanWhale, newPaymentMethod } = context;
  if (!newPaymentMethod) return null;

  const { label, text } = getPaymentCopy({ paymentMethod: newPaymentMethod });

  const updatedPlanCount = updatedPlans?.length;
  const title = !updatedPlanCount
    ? getCopy('paymentAdded.title')
    : getCopy('paymentSet.title');

  const contentAdded = (
    <Text margin={{ top: '32px' }}>{getCopy('paymentAdded.description')}</Text>
  );
  const contentSet = (
    <FlexCrate flexDirection="column" justifyContent="start">
      <Text margin={{ top: '32px', bottom: '32px' }}>
        {getCopy('paymentSet.descriptions.default')}
      </Text>
      <Text color="secondary" textStyle="heading500" tag="h3">
        {getCopy('paymentSet.subheading')}
      </Text>
      <ul>
        {updatedPlans?.map(plan => (
          <li key={plan.id}>
            <FlexCrate margin={{ top: '24px' }} alignItems="center">
              <Logo type="node" variant="accent" scale={2} aria-hidden={true} />
              <Text margin={{ left: '16px' }}>{plan.displayName}</Text>
            </FlexCrate>
          </li>
        ))}
      </ul>
    </FlexCrate>
  );
  const contentSetWhale = (
    <>
      <Text margin={{ top: '32px', bottom: '32px' }}>
        {getCopy('paymentSet.descriptions.whale', {
          count: updatedPlanCount,
        })}
      </Text>
      <Text textStyle="paragraph400" color="secondary">
        {getCopy('paymentSet.note')}
      </Text>
    </>
  );

  const content = () => {
    if (!updatedPlanCount) {
      return contentAdded;
    } else if (isActivePlanWhale) {
      return contentSetWhale;
    } else {
      return contentSet;
    }
  };

  return (
    <>
      <Modal.Content>
        <ButtonWrapper>
          <CloseButton
            onClick={close}
            icon="UIClose"
            aria-label={getCopy('buttons.close')}
          />
        </ButtonWrapper>
        <FlexCrate flexDirection="column" alignItems="center">
          <StyledSVG src={CheckmarkCircle} />
          <Text textStyle="heading800" tag="h2" margin={{ bottom: '32px' }}>
            {title}
          </Text>
          <PaymentCard>
            {label}
            {text}
          </PaymentCard>
          {content()}
        </FlexCrate>
      </Modal.Content>
      <Modal.Footer
        onSubmit={() => {
          trackClickEvent('paymentInformation.addPaymentModal.done');
          close();
        }}
        primaryText={getCopy('buttons.submit')}
      />
    </>
  );
};
